import React, { Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import RoutesWithSubRoutes from 'Routes/RoutesWithSubRoutes'
import type { RouteConfig, ContainerRouteConfig } from 'TypeDefs/Route'
import * as Sentry from '@sentry/react'
import { getEmailFromParam } from './util'

const SentryRoute = Sentry.withSentryRouting(Route)

const Fallback = () => <></>

type Props = {
  routes: (RouteConfig | ContainerRouteConfig)[]
}

const RenderRoutes = ({ routes }: Props) => {
  const loginHint = getEmailFromParam()
  return (
    <Suspense fallback={<Fallback />}>
      <Switch>
        {routes.map((route) => (
          <RoutesWithSubRoutes
            key={route.path}
            //  eslint-disable-next-line
            {...route}
            loginHint={loginHint}
          />
        ))}
        <SentryRoute
          render={() => {
            console.log('RenderRoutes: redirect to /')
            return <Redirect to={{ pathname: '/' }} />
          }}
        />
      </Switch>
    </Suspense>
  )
}

export default RenderRoutes
